export default __webpack_public_path__ + "static/media/latrip.83714d65.png";